module.exports = __webpack_public_path__ + "img/Admin Home.1c5a66fc.svg";